/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export const validate = (feature: BaseFeature) : Array<ValidationMessage> => {
    const errors: Array<ValidationMessage> = [];

    return errors;
};


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const PATH = feature.getSettingValue('PATH');
    if (PATH === '') {
        return blocks;
    }


    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        blockType: BlockType.CODE,
        id: `http_endpoint_requested_${PATH}`,
        template: `
@webserver.route('/${PATH}')
async def handler(r, w):
    data = r.query
    #****HTTP_ENDPOINT_REQUESTED_${PATH}****#
    w.write(b'HTTP/1.0 200 OK\\r\\n')
    w.write(f'Content-Type: text/plain\\r\\n')
    w.write(f'Access-Control-Allow-Origin: *\\r\\n')
    w.write(b'\\r\\n')
    await w.drain()`,
    });
    return blocks;
};
